import { ReactNode } from 'react'

import { useSetAtom } from 'jotai'

import {
  Text,
  Button,
  IndigoIndigo60,
  Primary13Regular
} from '@sequencehq/core-components'

import { RowControl } from 'Invoices/components'
import { currentEditorStepAtom, EditorStep } from '../../editor.atoms'

type Props = {
  icon: ReactNode
  iconBackground?: string
  title: string
  body: string | ReactNode
  hideBorderBottom?: boolean
  goToStep: EditorStep
  'data-testid'?: string
}

export const SummaryRow = (props: Props) => {
  const dataTestId = props['data-testid']

  return (
    <RowControl
      {...props}
      showActionOnHover
      action={
        <ButtonEdit
          goToStep={props.goToStep}
          data-testid={dataTestId && `${dataTestId}.edit`}
        />
      }
    />
  )
}

const ButtonEdit = ({
  goToStep,
  'data-testid': dataTestId
}: {
  goToStep: EditorStep
  'data-testid'?: string
}) => {
  const setStep = useSetAtom(currentEditorStepAtom)

  return (
    <Button
      variant="unstyled"
      style={{
        width: 'fit-content',
        minWidth: 'initial',
        padding: '0px',
        alignItems: 'flex-start'
      }}
      onClick={() => setStep(goToStep)}
      data-testid={dataTestId}
    >
      <Text {...Primary13Regular} color={IndigoIndigo60}>
        Edit
      </Text>
    </Button>
  )
}
